import { Component, OnInit } from '@angular/core';
import {ConstantValues} from '../../bpg-common/models/bpg-constants';

import { Router } from '@angular/router';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {

  constructor(
    private readonly router: Router,private readonly environment : EnvironmentConfiguration) { }
  read: any = ConstantValues.reportData.reportData;
  data1=[];

  ngOnInit() {
    if(this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod'){
 if(localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined ){
      this.router.navigate(['/log-out']);
    }}

    if (localStorage.getItem('logOutFlag') === "true"){
        this.router.navigate(['/log-out']); 
    }
    localStorage.removeItem('searchedEventsCaledarItems');
    sessionStorage.removeItem("MembershipData");
     this.data1 = this.read
  }
}
